import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Zap, Brain, Wrench, Users } from 'lucide-react';
import './Solutions.css';

const Solutions = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const solutions = [
    {
      icon: <Zap size={40} />,
      title: 'Intelligent Process Automation',
      description: 'Automate repetitive tasks, reporting, monitoring, and workflows with AI that operates flawlessly 24x7.',
    },
    {
      icon: <Brain size={40} />,
      title: 'Predictive & Decision AI',
      description: 'Make smarter decisions using AI-driven analytics, forecasting, and real-time insights.',
    },
    {
      icon: <Wrench size={40} />,
      title: 'Custom AI Software Development',
      description: 'We build AI solutions tailored to your exact business needs, not generic tools.',
    },
    {
      icon: <Users size={40} />,
      title: 'AI Workforce Replacement',
      description: 'Reduce manpower dependency while increasing productivity and accuracy.',
    },
  ];

  return (
    <section className="solutions-section" id="solutions" ref={ref} data-testid="solutions-section">
      <div className="container">
        <motion.div
          className="solutions-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="section-title" data-testid="solutions-title">
            Our Solutions
          </h2>
          <p className="section-subtitle" data-testid="solutions-subtitle">
            AI That Works Like Your Best Employee — But Smarter
          </p>
        </motion.div>

        <div className="solutions-grid">
          {solutions.map((solution, index) => (
            <motion.div
              key={index}
              className="solution-card glass-card"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.15, duration: 0.5, ease: 'easeOut' }}
              data-testid={`solution-${index}`}
            >
              <div className="solution-icon">{solution.icon}</div>
              <h3 className="solution-title">{solution.title}</h3>
              <p className="solution-description">{solution.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
